"use client";

import { useAuth, useUser } from "@clerk/nextjs";
import { useTelemetryIdentifyUser, useTelemetryReset } from "@workspace/telemetry/browser";
import { useEffect, useRef } from "react";

export default function ClerkTelemetryIdentity() {
  const { isLoaded, isSignedIn, userId } = useAuth();
  const { user } = useUser();
  const identifyUser = useTelemetryIdentifyUser();
  const resetTelemetry = useTelemetryReset();
  const wasSignedIn = useRef(false);

  useEffect(() => {
    if (!isLoaded) return;

    if (isSignedIn && userId && user) {
      identifyUser({
        id: userId,
        email: user.primaryEmailAddress?.emailAddress,
        firstName: user.firstName,
        lastName: user.lastName,
        fullName: user.fullName,
        createdAt: user.createdAt,
      });
      wasSignedIn.current = true;
      return;
    }

    if (wasSignedIn.current) {
      resetTelemetry();
      wasSignedIn.current = false;
    }
  }, [identifyUser, isLoaded, isSignedIn, resetTelemetry, user, userId]);

  return null;
}
